import type { AreaCatalog } from '../area';
import type { acts as en } from '../en/acts';

export const acts = {
  'acts.verb.start': 'Starten',
  'acts.verb.pause': 'Pausieren',
  'acts.verb.done': 'Fertig',
  'acts.verb.readyForReview': 'Bereit zur Review',
  'acts.verb.accept': 'Annehmen',
  'acts.verb.deny': 'Ablehnen',
  'acts.verb.cancel': 'Aufgabe abbrechen',
  'acts.verb.reopen': 'Wieder öffnen',
  'acts.verb.advance': 'Vorrücken',
  'acts.advance.refused': '{stage} · {reason}',
  'acts.advance.applies': '{stage} · setzt {means}',
} as const satisfies AreaCatalog<typeof en>;
